export const multiplayerLobby = {
  en: {
    noPlayersYet: 'No players yet',
    // Existing translations
    createTitle: 'Create a Room',
    stepChooseCategory: '1. Choose a Category',
    stepSelectDifficulty: '2. Select Difficulty',
    stepRoomType: '3. Room Type',
    public: 'Public',
    private: 'Private',
    buttonCreate: 'Create',
    room: 'Room',
    buttonCancel: 'Cancel',
    validationSelectCategory: 'Please select a category.',
    validationSelectDifficulty: 'Please select a difficulty.',
    noActiveRooms: 'Your next family room starts here',
    roomPlayersTitle: '{{roomName}} Players',
    loadingPlayers: 'Loading players...',
    host: 'Host',
    ready: 'Ready',
    waiting: 'Waiting',
    dayStreak: '{{count}} day streak',
    noPlayers: 'No players in this room yet',
    close: 'Close',
    openChat: 'Open chat',
    openEmojiPicker: 'Open emoji picker',
    chatHelp: 'Chat help. Tap for chat tips.',
    chatHelpDialog: 'Chat tips: Type a message and press send. Use the emoji button for quick reactions. Long press a message for more options.',
    messagePlaceholder: 'Type a message...',
    send: 'Send message',
    typingIndicator: 'Someone is typing…',
    scrollLatest: 'Scroll to latest messages',
    emojiCategoryReactions: 'Reactions',
    emojiCategoryFaces: 'Faces',
    emojiCategoryObjects: 'Objects',
    emojiCategorySymbols: 'Symbols',
    loadingRooms: 'Loading rooms...',
    shareJoinTeam: 'Join my team on Word of God Quiz! Tap this link: {{url}}',
    loadingCategories: 'Loading categories...',
    
    // New translations for missing hardcoded text
    loadingProfile: 'Loading your profile…',
    profileLoadFailed: 'Failed to load profile',
    multiplayerLobby: 'Multiplayer Lobby',
    groupLobbyTitle: '{{groupType}} lobby',
    groupGameRoom: '{{groupName}} Lobby',
    lobbySubtitle: 'Create a live room, bring everyone in, and keep your next family match moving.',
    realTimeGameDescription: 'Open a live {{groupType}} room and bring everyone in together.',
    realTimeGameButton: 'Start a Family Quiz',
    startGroupQuiz: 'Start a {{groupType}} quiz',
    challengeDescription: 'Send or accept quiz challenges to play at your own pace.',
    challengeButton: 'Challenge (Async)',
    backButton: '←',
    memberBadge: 'Family access',
    memberRoomTitle: 'Join a room or start your own',
    memberRoomDescription: 'Join an existing room, or start a free room for up to 3 players.',
    memberRoomEmptyTitle: 'No family room yet',
    memberRoomEmptyDescription: 'The next Premium-backed {{groupType}} room will appear here.',
    memberRoomChip: 'You can join as soon as the room opens.',
    setupCategoryBadge: 'Room Setup',
    setupCategoryTitle: 'Choose a room topic',
    setupCategorySubtitle: 'Pick what your {{groupType}} will play together.',
    setupTestamentBadge: 'Room Setup',
    setupTestamentTitle: 'Choose a room path',
    setupTestamentSubtitle: 'Choose how this {{groupType}} room will explore Scripture.',
    setupDifficultyTitle: 'Set the room challenge',
    setupDifficultySubtitle: 'Choose the challenge level for everyone in this {{groupType}} room.',
    roomCreateFailed: 'We could not create the room right now. Please try again.',
    hostEmptyEyebrow: 'Open room',
    hostEmptyTitle: 'Start your live {{groupType}} room',
    hostEmptyDescription: 'Create one room, invite everyone in, and keep the match moving from here.',
    hostActiveEyebrow: 'Live room',
    hostActiveTitle: 'Your {{groupType}} room is ready',
    hostActiveDescription: 'Open the room, check who is inside, and get the match started.',
    memberActiveEyebrow: 'Join room',
    memberActiveTitle: 'Your family room is live',
    memberActiveDescription: 'A Premium-backed room is open now. Join it here and keep the match moving.',
    
    // Game Room Card elements
    activeRooms: 'Active Rooms',
    gameRoomCode: 'Code',
    statusWaiting: 'waiting',
    statusPlaying: 'playing',
    statusLabel: 'Status',
    previewPlayers: 'Preview Players',
    joinRoom: 'Join Room',
    enterRoom: 'Enter Room',
    yourRoom: 'Your Room',
    gameRoom: 'Game Room',
    
    // Game Room Lobby elements
    shareInvite: 'Invite Friends',
    leaveRoom: 'Leave Room',
    iAmReady: "I'm Ready",
    cancelReady: 'Cancel Ready',
    playersFinished: '{{finished}} of {{total}} players finished',
    playersWaiting: '{{count}} player waiting',
    playersWaitingPlural: '{{count}} players waiting',
    waitingForPlayers: 'Waiting for at least 1 more player',
    startQuiz: 'Start Quiz',
    startingQuiz: 'Starting Quiz...',
    quizRoom: 'Quiz Room',
    playing: 'Playing',
    finished: 'Finished',
    disconnected: 'Disconnected',
    // host: 'Host', // Duplicate - already defined at line 18
    you: 'You',
    // ready: '✅ Ready', // Duplicate - already defined at line 19
    waitingStatus: 'Waiting',
    startGame: 'Start Quiz',
    starting: 'Starting Quiz...',
    gameRoomTitle: 'Quiz Room',
    hostLabel: 'Host',
    iAmReadyButton: "I'm Ready",
    readyButton: 'Ready',
    status: 'Status',
    category: 'Category',
    difficulty: 'Difficulty',
    roomDetails: 'Room Details',
    readyToBegin: 'Ready to Begin',
    allPlayersReady: 'Everyone is ready',
    waitingForHostToStart: 'Waiting for host to begin',
    playersInRoom: '{{count}} players in room',
    players: 'Players',
    readyUpToStart: 'Mark yourself ready so the host can start the quiz.',

    // Free host state (signed-in free users who can create capped rooms)
    freeHostEmptyEyebrow: 'Start free room',
    freeHostEmptyTitle: 'Start a free {{groupType}} room',
    freeHostEmptyDescription: 'Free rooms host up to 3 players. Upgrade to Premium for bigger games.',
    freeHostActiveEyebrow: 'Your room',
    freeHostActiveTitle: 'Your free {{groupType}} room is live',
    freeHostActiveDescription: 'Your room supports up to 3 players. Upgrade for more.',
    freeHostBadge: 'Free · up to 3 players',
    freeRoomFullTitle: 'Room is full',
    freeRoomFullMessage: 'Free rooms support up to 3 players. Upgrade to Premium to host bigger family and friends games.',
    roomFullGeneric: 'This room is full. Please try another.',
    loadingMultiplayerRoom: 'Loading multiplayer room...',
    loadingRoomDetails: 'Loading room details...',
    goBackAccessibility: 'Go back',
    playersListAccessibility: 'Players list. Shows all players, host, and ready status.',
    quickMatch: 'Quick Match',
    createRoomAction: 'Create Room',
    joinByCodeAction: 'Join by Code',
    shareInviteAccessibility: 'Share invite link',
    readyStatusUpdateFailed: 'Failed to update ready status. Please try again.',
  },
  es: {
    noPlayersYet: 'Aún no hay jugadores',
    setupCategoryBadge: 'Configuración de la sala',
    setupCategoryTitle: 'Elige un tema para la sala',
    setupCategorySubtitle: 'Elige qué jugará tu {{groupType}} en conjunto.',
    setupTestamentBadge: 'Configuración de la sala',
    setupTestamentTitle: 'Elige un recorrido para la sala',
    setupTestamentSubtitle: 'Elige cómo explorará las Escrituras esta sala de {{groupType}}.',
    setupDifficultyTitle: 'Define el reto de la sala',
    setupDifficultySubtitle: 'Elige el nivel de reto para todos en esta sala de {{groupType}}.',
    roomCreateFailed: 'No pudimos crear la sala en este momento. Inténtalo de nuevo.',
    // Existing translations
    createTitle: 'Crear una sala',
    stepChooseCategory: '1. Elige una categoría',
    stepSelectDifficulty: '2. Selecciona la dificultad',
    stepRoomType: '3. Tipo de sala',
    public: 'Pública',
    private: 'Privada',
    buttonCreate: 'Crear',
    room: 'Sala',
    buttonCancel: 'Cancelar',
    validationSelectCategory: 'Por favor selecciona una categoría.',
    validationSelectDifficulty: 'Por favor selecciona una dificultad.',
    noActiveRooms: 'No hay salas activas. ¡Sé el primero en crear una!',
    roomPlayersTitle: 'Jugadores de {{roomName}}',
    loadingPlayers: 'Cargando jugadores...',
    host: 'Anfitrión',
    ready: 'Listo',
    waiting: 'Esperando',
    dayStreak: '{{count}} días de racha',
    noPlayers: 'Aún no hay jugadores en esta sala',
    close: 'Cerrar',
    openChat: 'Abrir chat',
    openEmojiPicker: 'Abrir selector de emojis',
    chatHelp: 'Ayuda del chat. Toca para consejos.',
    chatHelpDialog: 'Consejos del chat: Escribe un mensaje y presiona enviar. Usa el botón de emoji para reacciones rápidas. Mantén presionado un mensaje para más opciones.',
    messagePlaceholder: 'Escribe un mensaje...',
    send: 'Enviar mensaje',
    typingIndicator: 'Alguien está escribiendo…',
    scrollLatest: 'Ir al último mensaje',
    emojiCategoryReactions: 'Reacciones',
    emojiCategoryFaces: 'Caras',
    emojiCategoryObjects: 'Objetos',
    emojiCategorySymbols: 'Símbolos',
    loadingRooms: 'Cargando salas...',
    shareJoinTeam: 'Únete a mi equipo en Word of God Quiz. Haz clic en este enlace: {{url}}',
    loadingCategories: 'Cargando categorías...',
    
    // New translations for missing hardcoded text
    loadingProfile: 'Cargando tu perfil…',
    profileLoadFailed: 'Error al cargar el perfil',
    multiplayerLobby: 'Sala Multijugador',
    groupGameRoom: 'Sala de Juego {{groupName}}',
    lobbySubtitle: 'Únete a una sala existente, crea la tuya propia, o usa emparejamiento rápido para jugar al instante.',
    realTimeGameDescription: '¡Juega en vivo con tu {{groupType}} en una sala de preguntas en tiempo real!',
    realTimeGameButton: 'Iniciar Quiz Familiar',
    challengeDescription: 'Envía o acepta desafíos de preguntas para jugar a tu propio ritmo.',
    challengeButton: 'Desafío (Asíncrono)',
    backButton: '←',
    
    // Game Room Card elements
    activeRooms: 'Salas Activas',
    gameRoomCode: 'Código',
    statusWaiting: 'esperando',
    statusPlaying: 'jugando',
    statusLabel: 'Estado',
    previewPlayers: 'Vista Previa Jugadores',
    joinRoom: 'Unirse a Sala',
    enterRoom: 'Entrar a Sala',
    yourRoom: 'Tu Sala',
    gameRoom: 'Sala de Juego',
    
    // Game Room Lobby elements
    shareInvite: 'Invitar Amigos',
    leaveRoom: 'Salir de Sala',
    iAmReady: 'Estoy Listo',
    cancelReady: 'Cancelar Listo',
    playersFinished: '{{finished}} de {{total}} jugadores terminados',
    playersWaiting: '{{count}} jugador esperando',
    playersWaitingPlural: '{{count}} jugadores esperando',
    waitingForPlayers: 'Esperando al menos 1 jugador más',
    startQuiz: 'Iniciar Quiz',
    startingQuiz: 'Iniciando Quiz...',
    quizRoom: 'Sala de Quiz',
    playing: 'Jugando',
    finished: 'Terminado',
    disconnected: 'Desconectado',
    // host: 'Anfitrión', // Duplicate - already defined at line 103
    you: 'Tú',
    // ready: '✅ Listo', // Duplicate - already defined at line 104
    waitingStatus: 'Esperando',
    startGame: 'Iniciar Quiz',
    starting: 'Iniciando Quiz...',
    gameRoomTitle: 'Sala de Quiz',
    hostLabel: 'Anfitrión',
    iAmReadyButton: 'Estoy listo',
    readyButton: 'Listo',
    status: 'Estado',
    category: 'Categoría',
    difficulty: 'Dificultad',
    memberRoomTitle: 'Únete a una sala o crea la tuya',
    memberRoomDescription: 'Únete a una sala existente o inicia una sala gratuita para hasta 3 jugadores.',
    freeHostEmptyEyebrow: 'Iniciar sala gratuita',
    freeHostEmptyTitle: 'Iniciar una sala gratuita de {{groupType}}',
    freeHostEmptyDescription: 'Las salas gratuitas admiten hasta 3 jugadores. Actualiza a Premium para juegos más grandes.',
    freeHostActiveEyebrow: 'Tu sala',
    freeHostActiveTitle: 'Tu sala gratuita de {{groupType}} está activa',
    freeHostActiveDescription: 'Tu sala admite hasta 3 jugadores. Actualiza para más.',
    freeHostBadge: 'Gratis · hasta 3 jugadores',
    freeRoomFullTitle: 'Sala llena',
    freeRoomFullMessage: 'Las salas gratuitas admiten hasta 3 jugadores. Actualiza a Premium para juegos familiares más grandes.',
    roomFullGeneric: 'Esta sala está llena. Intenta con otra.',
    loadingMultiplayerRoom: 'Cargando sala multijugador...',
    loadingRoomDetails: 'Cargando detalles de la sala...',
    goBackAccessibility: 'Volver',
    playersListAccessibility: 'Lista de jugadores. Muestra todos los jugadores, el anfitrión y el estado de listo.',
    quickMatch: 'Partida rápida',
    createRoomAction: 'Crear sala',
    joinByCodeAction: 'Unirse con código',
    shareInviteAccessibility: 'Compartir enlace de invitación',
    readyStatusUpdateFailed: 'No se pudo actualizar el estado de listo. Inténtalo de nuevo.',
    waitingForHostToStart: 'Esperando a que el anfitrión empiece',
    playersInRoom: '{{count}} jugadores en la sala',
    readyUpToStart: 'Márcate como listo para que el anfitrión pueda iniciar el quiz.',
    allPlayersReady: 'Todos están listos',
    roomDetails: 'Detalles de la sala',
    players: 'Jugadores',
    readyToBegin: 'Listo para empezar',
    groupLobbyTitle: 'Sala de {{groupType}}',
    hostActiveDescription: 'Abre la sala, revisa quién está dentro y empieza la partida.',
    memberActiveDescription: 'Hay una sala Premium abierta. Únete aquí y mantén la partida activa.',
    hostEmptyDescription: 'Crea una sala, invita a todos y controla la partida desde aquí.',
    hostActiveEyebrow: 'Sala en vivo',
    memberActiveEyebrow: 'Unirse a sala',
    hostEmptyEyebrow: 'Abrir sala',
    memberBadge: 'Acceso familiar',
    hostActiveTitle: 'Tu sala de {{groupType}} está lista',
    memberActiveTitle: 'Tu sala familiar está activa',
    hostEmptyTitle: 'Inicia tu sala en vivo de {{groupType}}',
    startGroupQuiz: 'Iniciar quiz de {{groupType}}',
    memberRoomEmptyTitle: 'Aún no hay sala familiar',
    memberRoomEmptyDescription: 'La próxima sala Premium de {{groupType}} aparecerá aquí.',
    memberRoomChip: 'Podrás unirte cuando la sala se abra.',
  },

  fr: {
    noPlayersYet: 'Aucun joueur pour le moment',
    setupCategoryBadge: 'Configuration du salon',
    setupCategoryTitle: 'Choisissez un thème',
    setupCategorySubtitle: 'Choisissez ce que votre {{groupType}} jouera ensemble.',
    setupTestamentBadge: 'Configuration du salon',
    setupTestamentTitle: 'Choisissez un parcours',
    setupTestamentSubtitle: 'Choisissez comment ce salon {{groupType}} explorera les Écritures.',
    setupDifficultyTitle: 'Définissez le défi du salon',
    setupDifficultySubtitle: 'Choisissez le niveau de défi pour tous dans ce salon {{groupType}}.',
    roomCreateFailed: 'Impossible de créer le salon pour le moment. Veuillez réessayer.',
    // French translations
    createTitle: 'Créer une Salle',
    stepChooseCategory: '1. Choisir une Catégorie',
    stepSelectDifficulty: '2. Sélectionner la Difficulté',
    stepRoomType: '3. Type de Salle',
    public: 'Publique',
    private: 'Privée',
    buttonCreate: 'Créer',
    room: 'Salle',
    buttonCancel: 'Annuler',
    validationSelectCategory: 'Veuillez sélectionner une catégorie.',
    validationSelectDifficulty: 'Veuillez sélectionner une difficulté.',
    noActiveRooms: 'Aucune salle active. Soyez le premier à en créer une !',
    roomPlayersTitle: 'Joueurs de {{roomName}}',
    loadingPlayers: 'Chargement des joueurs...',
    host: 'Hôte',
    ready: 'Prêt',
    waiting: 'En attente',
    dayStreak: '{{count}} jours de suite',
    noPlayers: 'Aucun joueur dans cette salle pour le moment',
    close: 'Fermer',
    openChat: 'Ouvrir le chat',
    openEmojiPicker: 'Ouvrir le sélecteur d\'emoji',
    chatHelp: 'Aide du chat. Tapez pour des conseils.',
    chatHelpDialog: 'Conseils de chat : Tapez un message et appuyez sur envoyer. Utilisez le bouton emoji pour des réactions rapides. Appuyez longuement sur un message pour plus d\'options.',
    messagePlaceholder: 'Tapez un message...',
    send: 'Envoyer le message',
    typingIndicator: 'Quelqu\'un écrit…',
    scrollLatest: 'Faire défiler vers les derniers messages',
    emojiCategoryReactions: 'Réactions',
    emojiCategoryFaces: 'Visages',
    emojiCategoryObjects: 'Objets',
    emojiCategorySymbols: 'Symboles',
    loadingRooms: 'Chargement des salles...',
    shareJoinTeam: 'Rejoignez mon équipe sur Word of God Quiz ! Cliquez sur ce lien : {{url}}',
    loadingCategories: 'Chargement des catégories...',
    loadingProfile: 'Chargement de votre profil…',
    profileLoadFailed: 'Échec du chargement du profil',
    multiplayerLobby: 'Salon Multijoueur',
    groupGameRoom: 'Salle de Jeu {{groupName}}',
    lobbySubtitle: 'Rejoignez une salle existante, créez la vôtre, ou utilisez la correspondance rapide pour jouer instantanément.',
    realTimeGameDescription: 'Jouez en direct avec votre {{groupType}} dans une salle de quiz en temps réel !',
    realTimeGameButton: 'Lancer un Quiz en Famille',
    challengeDescription: 'Envoyez ou acceptez des défis de quiz pour jouer à votre rythme.',
    challengeButton: 'Défi (Asynchrone)',
    backButton: '←',
    
    // Game Room Card elements
    activeRooms: 'Salles Actives',
    gameRoomCode: 'Code',
    statusWaiting: 'en attente',
    statusPlaying: 'en cours',
    statusLabel: 'Statut',
    previewPlayers: 'Aperçu Joueurs',
    joinRoom: 'Rejoindre Salle',
    enterRoom: 'Entrer Salle',
    yourRoom: 'Votre Salle',
    gameRoom: 'Salle de Jeu',
    
    // Game Room Lobby elements
    shareInvite: 'Inviter des Amis',
    leaveRoom: 'Quitter la Salle',
    iAmReady: 'Je suis Prêt',
    cancelReady: 'Annuler Prêt',
    playersFinished: '{{finished}} sur {{total}} joueurs terminés',
    playersWaiting: '{{count}} joueur en attente',
    playersWaitingPlural: '{{count}} joueurs en attente',
    waitingForPlayers: 'En attente d\'au moins 1 joueur de plus',
    startQuiz: 'Lancer le Quiz',
    startingQuiz: 'Lancement du Quiz...',
    quizRoom: 'Salle de Quiz',
    playing: 'En cours',
    finished: 'Terminé',
    disconnected: 'Déconnecté',
    // host: 'Hôte', // Duplicate - already defined at line 189
    you: 'Vous',
    // ready: '✅ Prêt', // Duplicate - already defined at line 190
    waitingStatus: 'En attente',
    startGame: 'Lancer le Quiz',
    starting: 'Lancement du Quiz...',
    gameRoomTitle: 'Salle de Quiz',
    hostLabel: 'Hôte',
    iAmReadyButton: 'Je suis prêt',
    readyButton: 'Prêt',
    memberRoomTitle: 'Rejoignez une salle ou créez la vôtre',
    memberRoomDescription: 'Rejoignez une salle existante ou créez une salle gratuite pour jusqu\'à 3 joueurs.',
    freeHostEmptyEyebrow: 'Créer une salle gratuite',
    freeHostEmptyTitle: 'Créer une salle gratuite de {{groupType}}',
    freeHostEmptyDescription: 'Les salles gratuites accueillent jusqu\'à 3 joueurs. Passez à Premium pour des parties plus grandes.',
    freeHostActiveEyebrow: 'Votre salle',
    freeHostActiveTitle: 'Votre salle gratuite de {{groupType}} est en direct',
    freeHostActiveDescription: 'Votre salle accueille jusqu\'à 3 joueurs. Passez à Premium pour plus.',
    freeHostBadge: 'Gratuit · jusqu\'à 3 joueurs',
    freeRoomFullTitle: 'Salle pleine',
    freeRoomFullMessage: 'Les salles gratuites accueillent jusqu\'à 3 joueurs. Passez à Premium pour des jeux en famille plus grands.',
    roomFullGeneric: 'Cette salle est pleine. Veuillez en essayer une autre.',
    loadingMultiplayerRoom: 'Chargement de la salle multijoueur...',
    loadingRoomDetails: 'Chargement des détails de la salle...',
    goBackAccessibility: 'Retour',
    playersListAccessibility: 'Liste des joueurs. Affiche tous les joueurs, l hote et le statut prêt.',
    quickMatch: 'Partie rapide',
    createRoomAction: 'Créer une salle',
    joinByCodeAction: 'Rejoindre par code',
    shareInviteAccessibility: 'Partager le lien d invitation',
    readyStatusUpdateFailed: 'Impossible de mettre a jour le statut prêt. Veuillez réessayer.',
    waitingForHostToStart: 'En attente que l hote commence',
    playersInRoom: '{{count}} joueurs dans la salle',
    readyUpToStart: 'Indiquez que vous êtes prêt afin que l hote puisse lancer le quiz.',
    allPlayersReady: 'Tout le monde est prêt',
    roomDetails: 'Détails de la salle',
    players: 'Joueurs',
    readyToBegin: 'Prêt a commencer',
    groupLobbyTitle: 'Salon {{groupType}}',
    hostActiveDescription: 'Ouvrez la salle, verifiez qui est present et lancez la partie.',
    memberActiveDescription: 'Une salle Premium est ouverte. Rejoignez-la ici et continuez la partie.',
    hostEmptyDescription: 'Créez une salle, invitez tout le monde et gardez la partie en mouvement.',
    hostActiveEyebrow: 'Salle en direct',
    memberActiveEyebrow: 'Rejoindre la salle',
    hostEmptyEyebrow: 'Ouvrir une salle',
    memberBadge: 'Acces famille',
    hostActiveTitle: 'Votre salle {{groupType}} est prete',
    memberActiveTitle: 'Votre salle familiale est en direct',
    hostEmptyTitle: 'Lancez votre salle {{groupType}} en direct',
    startGroupQuiz: 'Lancer un quiz {{groupType}}',
    memberRoomEmptyTitle: 'Aucune salle familiale pour le moment',
    memberRoomEmptyDescription: 'La prochaine salle Premium {{groupType}} apparaîtra ici.',
    memberRoomChip: 'Vous pourrez rejoindre des que la salle ouvrira.',
    status: 'Statut',
    category: 'Catégorie',
    difficulty: 'Difficulté',
  },

  de: {
    noPlayersYet: 'Noch keine Spieler',
    setupCategoryBadge: 'Raum-Einrichtung',
    setupCategoryTitle: 'Wähle ein Raumthema',
    setupCategorySubtitle: 'Wähle, was deine {{groupType}}-Gruppe gemeinsam spielt.',
    setupTestamentBadge: 'Raum-Einrichtung',
    setupTestamentTitle: 'Wähle einen Raum-Pfad',
    setupTestamentSubtitle: 'Wähle, wie dieser {{groupType}}-Raum die Schrift erkundet.',
    setupDifficultyTitle: 'Lege die Herausforderung fest',
    setupDifficultySubtitle: 'Wähle die Schwierigkeitsstufe für alle in diesem {{groupType}}-Raum.',
    roomCreateFailed: 'Der Raum konnte gerade nicht erstellt werden. Bitte versuche es erneut.',
    // German translations
    createTitle: 'Einen Raum Erstellen',
    stepChooseCategory: '1. Kategorie Wählen',
    stepSelectDifficulty: '2. Schwierigkeit Wählen',
    stepRoomType: '3. Raumtyp',
    public: 'Öffentlich',
    private: 'Privat',
    buttonCreate: 'Erstellen',
    room: 'Raum',
    buttonCancel: 'Abbrechen',
    validationSelectCategory: 'Bitte wählen Sie eine Kategorie.',
    validationSelectDifficulty: 'Bitte wählen Sie eine Schwierigkeit.',
    noActiveRooms: 'Keine aktiven Räume. Seien Sie der Erste, der einen erstellt!',
    roomPlayersTitle: '{{roomName}} Spieler',
    loadingPlayers: 'Lade Spieler...',
    host: 'Gastgeber',
    ready: 'Bereit',
    waiting: 'Warten',
    dayStreak: '{{count}} Tage Streak',
    noPlayers: 'Noch keine Spieler in diesem Raum',
    close: 'Schließen',
    openChat: 'Chat öffnen',
    openEmojiPicker: 'Emoji-Auswahl öffnen',
    chatHelp: 'Chat-Hilfe. Tippen für Tipps.',
    chatHelpDialog: 'Chat-Tipps: Nachricht eingeben und senden drücken. Emoji-Button für schnelle Reaktionen verwenden. Nachricht lange drücken für mehr Optionen.',
    messagePlaceholder: 'Nachricht eingeben...',
    send: 'Nachricht senden',
    typingIndicator: 'Jemand tippt…',
    scrollLatest: 'Zu neuesten Nachrichten scrollen',
    emojiCategoryReactions: 'Reaktionen',
    emojiCategoryFaces: 'Gesichter',
    emojiCategoryObjects: 'Objekte',
    emojiCategorySymbols: 'Symbole',
    loadingRooms: 'Lade Räume...',
    shareJoinTeam: 'Tritt meinem Team bei Word of God Quiz bei! Tippe auf diesen Link: {{url}}',
    loadingCategories: 'Lade Kategorien...',
    loadingProfile: 'Lade Ihr Profil…',
    profileLoadFailed: 'Profil konnte nicht geladen werden',
    multiplayerLobby: 'Mehrspieler-Lobby',
    groupGameRoom: '{{groupName}} Spielraum',
    lobbySubtitle: 'Einem bestehenden Raum beitreten, eigenen erstellen oder Quick Match für sofortiges Spielen verwenden.',
    realTimeGameDescription: 'Spielen Sie live mit Ihrer {{groupType}} in einem Echtzeit-Quiz-Raum!',
    realTimeGameButton: 'Familien-Quiz starten',
    challengeDescription: 'Quiz-Herausforderungen senden oder annehmen, um in Ihrem eigenen Tempo zu spielen.',
    challengeButton: 'Herausforderung (Asynchron)',
    backButton: '←',
    
    // Game Room Card elements
    activeRooms: 'Aktive Räume',
    gameRoomCode: 'Code',
    statusWaiting: 'wartend',
    statusPlaying: 'spielend',
    statusLabel: 'Status',
    previewPlayers: 'Spieler Vorschau',
    joinRoom: 'Raum Beitreten',
    enterRoom: 'Raum Betreten',
    yourRoom: 'Ihr Raum',
    gameRoom: 'Spielraum',
    
    // Game Room Lobby elements
    shareInvite: 'Freunde Einladen',
    leaveRoom: 'Raum Verlassen',
    iAmReady: 'Ich bin Bereit',
    cancelReady: 'Bereit Abbrechen',
    playersFinished: '{{finished}} von {{total}} Spielern fertig',
    playersWaiting: '{{count}} Spieler wartet',
    playersWaitingPlural: '{{count}} Spieler warten',
    waitingForPlayers: 'Warten auf mindestens 1 weiteren Spieler',
    startQuiz: 'Quiz Starten',
    startingQuiz: 'Quiz startet...',
    quizRoom: 'Quiz-Raum',
    playing: 'Spielend',
    finished: 'Fertig',
    disconnected: 'Getrennt',
    // host: 'Gastgeber', // Duplicate - already defined at line 270
    you: 'Sie',
    // ready: '✅ Bereit', // Duplicate - already defined at line 271
    waitingStatus: 'Wartend',
    startGame: 'Quiz Starten',
    starting: 'Quiz startet...',
    gameRoomTitle: 'Quiz-Raum',
    hostLabel: 'Gastgeber',
    iAmReadyButton: 'Ich bin bereit',
    readyButton: 'Bereit',
    memberRoomTitle: 'Tritt einem Raum bei oder erstelle deinen eigenen',
    memberRoomDescription: 'Tritt einem bestehenden Raum bei oder starte einen kostenlosen Raum für bis zu 3 Spieler.',
    freeHostEmptyEyebrow: 'Kostenlosen Raum starten',
    freeHostEmptyTitle: 'Kostenlosen {{groupType}}-Raum starten',
    freeHostEmptyDescription: 'Kostenlose Räume für bis zu 3 Spieler. Upgrade auf Premium für größere Spiele.',
    freeHostActiveEyebrow: 'Dein Raum',
    freeHostActiveTitle: 'Dein kostenloser {{groupType}}-Raum ist live',
    freeHostActiveDescription: 'Dein Raum unterstützt bis zu 3 Spieler. Upgrade für mehr.',
    freeHostBadge: 'Kostenlos · bis zu 3 Spieler',
    freeRoomFullTitle: 'Raum voll',
    freeRoomFullMessage: 'Kostenlose Räume unterstützen bis zu 3 Spieler. Upgrade auf Premium für größere Familien- und Freundesspiele.',
    roomFullGeneric: 'Dieser Raum ist voll. Bitte versuche einen anderen.',
    loadingMultiplayerRoom: 'Mehrspielerraum wird geladen...',
    loadingRoomDetails: 'Raumdetails werden geladen...',
    goBackAccessibility: 'Zurück',
    playersListAccessibility: 'Spielerliste. Zeigt alle Spieler, den Gastgeber und den Bereit-Status.',
    quickMatch: 'Schnelles Spiel',
    createRoomAction: 'Raum erstellen',
    joinByCodeAction: 'Mit Code beitreten',
    shareInviteAccessibility: 'Einladungslink teilen',
    readyStatusUpdateFailed: 'Bereit-Status konnte nicht aktualisiert werden. Bitte versuche es erneut.',
    waitingForHostToStart: 'Warten auf den Gastgeber',
    playersInRoom: '{{count}} Spieler im Raum',
    readyUpToStart: 'Markiere dich als bereit, damit der Gastgeber das Quiz starten kann.',
    allPlayersReady: 'Alle sind bereit',
    roomDetails: 'Raumdetails',
    players: 'Spieler',
    readyToBegin: 'Bereit zum Start',
    groupLobbyTitle: '{{groupType}} Lobby',
    hostActiveDescription: 'Öffne den Raum, prüfe wer dabei ist und starte die Runde.',
    memberActiveDescription: 'Ein Premium-Raum ist jetzt offen. Tritt hier bei und halte die Runde in Bewegung.',
    hostEmptyDescription: 'Erstelle einen Raum, lade alle ein und steuere die Runde von hier.',
    hostActiveEyebrow: 'Live-Raum',
    memberActiveEyebrow: 'Raum beitreten',
    hostEmptyEyebrow: 'Raum öffnen',
    memberBadge: 'Familienzugang',
    hostActiveTitle: 'Dein {{groupType}} Raum ist bereit',
    memberActiveTitle: 'Dein Familienraum ist live',
    hostEmptyTitle: 'Starte deinen Live-{{groupType}} Raum',
    startGroupQuiz: '{{groupType}} Quiz starten',
    memberRoomEmptyTitle: 'Noch kein Familienraum',
    memberRoomEmptyDescription: 'Der nächste Premium-{{groupType}} Raum erscheint hier.',
    memberRoomChip: 'Du kannst beitreten, sobald der Raum öffnet.',
    status: 'Status',
    category: 'Kategorie',
    difficulty: 'Schwierigkeit',
  },
  
  pt: {
    noPlayersYet: 'Ainda não há jogadores',
    setupCategoryBadge: 'Configuração da sala',
    setupCategoryTitle: 'Escolha um tema para a sala',
    setupCategorySubtitle: 'Escolha o que seu grupo de {{groupType}} jogará junto.',
    setupTestamentBadge: 'Configuração da sala',
    setupTestamentTitle: 'Escolha um caminho para a sala',
    setupTestamentSubtitle: 'Escolha como esta sala de {{groupType}} explorará as Escrituras.',
    setupDifficultyTitle: 'Defina o desafio da sala',
    setupDifficultySubtitle: 'Escolha o nível de desafio para todos nesta sala de {{groupType}}.',
    roomCreateFailed: 'Não foi possível criar a sala agora. Tente novamente.',
    // Portuguese translations
    createTitle: 'Criar uma Sala',
    stepChooseCategory: '1. Escolha uma Categoria',
    stepSelectDifficulty: '2. Selecione a Dificuldade',
    stepRoomType: '3. Tipo de Sala',
    public: 'Pública',
    private: 'Privada',
    buttonCreate: 'Criar',
    room: 'Sala',
    buttonCancel: 'Cancelar',
    validationSelectCategory: 'Por favor, selecione uma categoria.',
    validationSelectDifficulty: 'Por favor, selecione uma dificuldade.',
    noActiveRooms: 'Nenhuma sala ativa. Seja o primeiro a criar uma!',
    roomPlayersTitle: 'Jogadores de {{roomName}}',
    loadingPlayers: 'Carregando jogadores...',
    host: 'Anfitrião',
    ready: 'Pronto',
    waiting: 'Aguardando',
    dayStreak: '{{count}} dias seguidos',
    noPlayers: 'Ainda não há jogadores nesta sala',
    close: 'Fechar',
    openChat: 'Abrir chat',
    openEmojiPicker: 'Abrir seletor de emoji',
    chatHelp: 'Ajuda do chat. Toque para dicas.',
    chatHelpDialog: 'Dicas do chat: Digite uma mensagem e pressione enviar. Use o botão emoji para reações rápidas. Pressione e segure uma mensagem para mais opções.',
    messagePlaceholder: 'Digite uma mensagem...',
    send: 'Enviar mensagem',
    typingIndicator: 'Alguém está digitando…',
    scrollLatest: 'Rolar para as mensagens mais recentes',
    emojiCategoryReactions: 'Reações',
    emojiCategoryFaces: 'Rostos',
    emojiCategoryObjects: 'Objetos',
    emojiCategorySymbols: 'Símbolos',
    loadingRooms: 'Carregando salas...',
    shareJoinTeam: 'Junte-se à minha equipe no Word of God Quiz! Toque neste link: {{url}}',
    loadingCategories: 'Carregando categorias...',
    loadingProfile: 'Carregando seu perfil…',
    profileLoadFailed: 'Falha ao carregar o perfil',
    multiplayerLobby: 'Lobby Multijogador',
    groupGameRoom: 'Sala de Jogo {{groupName}}',
    lobbySubtitle: 'Junte-se a uma sala existente, crie a sua própria, ou use correspondência rápida para jogar instantaneamente.',
    realTimeGameDescription: 'Jogue ao vivo com seu {{groupType}} em uma sala de quiz em tempo real!',
    realTimeGameButton: 'Iniciar Quiz em Família',
    challengeDescription: 'Envie ou aceite desafios de quiz para jogar no seu próprio ritmo.',
    challengeButton: 'Desafio (Assíncrono)',
    backButton: '←',
    
    // Game Room Card elements
    activeRooms: 'Salas Ativas',
    gameRoomCode: 'Código',
    statusWaiting: 'aguardando',
    statusPlaying: 'jogando',
    statusLabel: 'Status',
    previewPlayers: 'Prévia Jogadores',
    joinRoom: 'Entrar na Sala',
    enterRoom: 'Entrar na Sala',
    yourRoom: 'Sua Sala',
    gameRoom: 'Sala de Jogo',
    
    // Game Room Lobby elements
    shareInvite: 'Convidar Amigos',
    leaveRoom: 'Sair da Sala',
    iAmReady: 'Estou Pronto',
    cancelReady: 'Cancelar Pronto',
    playersFinished: '{{finished}} de {{total}} jogadores terminaram',
    playersWaiting: '{{count}} jogador aguardando',
    playersWaitingPlural: '{{count}} jogadores aguardando',
    waitingForPlayers: 'Aguardando pelo menos mais 1 jogador',
    startQuiz: 'Iniciar Quiz',
    startingQuiz: 'Iniciando Quiz...',
    quizRoom: 'Sala de Quiz',
    playing: 'Jogando',
    finished: 'Terminado',
    disconnected: 'Desconectado',
    // host: 'Anfitrião', // Duplicate - already defined at line 351
    you: 'Você',
    // ready: '✅ Pronto', // Duplicate - already defined at line 352
    waitingStatus: 'Aguardando',
    startGame: 'Iniciar Quiz',
    starting: 'Iniciando Quiz...',
    gameRoomTitle: 'Sala de Quiz',
    hostLabel: 'Anfitrião',
    iAmReadyButton: 'Estou pronto',
    readyButton: 'Pronto',
    memberRoomTitle: 'Entre em uma sala ou crie a sua',
    memberRoomDescription: 'Entre em uma sala existente ou inicie uma sala gratuita para até 3 jogadores.',
    freeHostEmptyEyebrow: 'Iniciar sala gratuita',
    freeHostEmptyTitle: 'Iniciar uma sala gratuita de {{groupType}}',
    freeHostEmptyDescription: 'Salas gratuitas comportam até 3 jogadores. Atualize para Premium para jogos maiores.',
    freeHostActiveEyebrow: 'Sua sala',
    freeHostActiveTitle: 'Sua sala gratuita de {{groupType}} está ao vivo',
    freeHostActiveDescription: 'Sua sala comporta até 3 jogadores. Atualize para mais.',
    freeHostBadge: 'Grátis · até 3 jogadores',
    freeRoomFullTitle: 'Sala cheia',
    freeRoomFullMessage: 'Salas gratuitas comportam até 3 jogadores. Atualize para Premium para jogos maiores com família e amigos.',
    roomFullGeneric: 'Esta sala está cheia. Tente outra.',
    loadingMultiplayerRoom: 'Carregando sala multijogador...',
    loadingRoomDetails: 'Carregando detalhes da sala...',
    goBackAccessibility: 'Voltar',
    playersListAccessibility: 'Lista de jogadores. Mostra todos os jogadores, anfitrião e status de pronto.',
    quickMatch: 'Partida rápida',
    createRoomAction: 'Criar sala',
    joinByCodeAction: 'Entrar com código',
    shareInviteAccessibility: 'Compartilhar link de convite',
    readyStatusUpdateFailed: 'Não foi possível atualizar o status de pronto. Tente novamente.',
    waitingForHostToStart: 'Aguardando o anfitrião iniciar',
    playersInRoom: '{{count}} jogadores na sala',
    readyUpToStart: 'Marque-se como pronto para que o anfitrião possa iniciar o quiz.',
    allPlayersReady: 'Todos estão prontos',
    roomDetails: 'Detalhes da sala',
    players: 'Jogadores',
    readyToBegin: 'Pronto para começar',
    groupLobbyTitle: 'Lobby de {{groupType}}',
    hostActiveDescription: 'Abra a sala, veja quem entrou e inicie a partida.',
    memberActiveDescription: 'Uma sala Premium está aberta. Entre aqui e mantenha a partida em andamento.',
    hostEmptyDescription: 'Crie uma sala, convide todos e conduza a partida daqui.',
    hostActiveEyebrow: 'Sala ao vivo',
    memberActiveEyebrow: 'Entrar na sala',
    hostEmptyEyebrow: 'Abrir sala',
    memberBadge: 'Acesso familiar',
    hostActiveTitle: 'Sua sala de {{groupType}} está pronta',
    memberActiveTitle: 'Sua sala familiar está ao vivo',
    hostEmptyTitle: 'Inicie sua sala ao vivo de {{groupType}}',
    startGroupQuiz: 'Iniciar quiz de {{groupType}}',
    memberRoomEmptyTitle: 'Ainda não há sala familiar',
    memberRoomEmptyDescription: 'A próxima sala Premium de {{groupType}} aparecerá aqui.',
    memberRoomChip: 'Você poderá entrar assim que a sala abrir.',
    status: 'Status',
    category: 'Categoria',
    difficulty: 'Dificuldade',
  },

  // Adding remaining 5 languages: ru, tl, it, am, ko
  ru: {
    noPlayersYet: 'Игроков пока нет',
    setupCategoryBadge: 'Настройка комнаты',
    setupCategoryTitle: 'Выберите тему комнаты',
    setupCategorySubtitle: 'Выберите, во что будет играть ваша группа ({{groupType}}).',
    setupTestamentBadge: 'Настройка комнаты',
    setupTestamentTitle: 'Выберите путь комнаты',
    setupTestamentSubtitle: 'Выберите, как эта комната ({{groupType}}) будет изучать Писание.',
    setupDifficultyTitle: 'Выберите сложность комнаты',
    setupDifficultySubtitle: 'Выберите уровень сложности для всех в этой комнате ({{groupType}}).',
    roomCreateFailed: 'Сейчас не удалось создать комнату. Попробуйте ещё раз.',
    // Russian translations
    createTitle: 'Создать Комнату',
    stepChooseCategory: '1. Выбрать Категорию',
    stepSelectDifficulty: '2. Выбрать Сложность',
    stepRoomType: '3. Тип Комнаты',
    public: 'Публичная',
    private: 'Частная',
    buttonCreate: 'Создать',
    room: 'Комната',
    buttonCancel: 'Отмена',
    validationSelectCategory: 'Пожалуйста, выберите категорию.',
    validationSelectDifficulty: 'Пожалуйста, выберите сложность.',
    noActiveRooms: 'Нет активных комнат. Будьте первым, кто создаст!',
    roomPlayersTitle: 'Игроки {{roomName}}',
    loadingPlayers: 'Загрузка игроков...',
    host: 'Хост',
    ready: 'Готов',
    waiting: 'Ожидание',
    dayStreak: '{{count}} дней подряд',
    noPlayers: 'Пока нет игроков в этой комнате',
    close: 'Закрыть',
    openChat: 'Открыть чат',
    openEmojiPicker: 'Открыть выбор эмодзи',
    chatHelp: 'Помощь по чату. Нажмите для советов.',
    chatHelpDialog: 'Советы по чату: Введите сообщение и нажмите отправить. Используйте кнопку эмодзи для быстрых реакций. Долго нажимайте на сообщение для дополнительных опций.',
    messagePlaceholder: 'Введите сообщение...',
    send: 'Отправить сообщение',
    typingIndicator: 'Кто-то печатает…',
    scrollLatest: 'Прокрутить к последним сообщениям',
    emojiCategoryReactions: 'Реакции',
    emojiCategoryFaces: 'Лица',
    emojiCategoryObjects: 'Объекты',
    emojiCategorySymbols: 'Символы',
    loadingRooms: 'Загрузка комнат...',
    shareJoinTeam: 'Присоединяйтесь к моей команде в Word of God Quiz! Нажмите на эту ссылку: {{url}}',
    loadingCategories: 'Загрузка категорий...',
    loadingProfile: 'Загрузка вашего профиля…',
    profileLoadFailed: 'Не удалось загрузить профиль',
    multiplayerLobby: 'Многопользовательское Лобби',
    groupGameRoom: 'Игровая Комната {{groupName}}',
    lobbySubtitle: 'Присоединитесь к существующей комнате, создайте свою собственную или используйте быстрый поиск для мгновенной игры.',
    realTimeGameDescription: 'Играйте в прямом эфире с вашей {{groupType}} в комнате викторины в реальном времени!',
    realTimeGameButton: 'Начать Семейную Викторину',
    challengeDescription: 'Отправляйте или принимайте вызовы викторины, чтобы играть в своем темпе.',
    challengeButton: 'Вызов (Асинхронный)',
    backButton: '←',
    
    // Game Room Card elements
    activeRooms: 'Активные Комнаты',
    gameRoomCode: 'Код',
    statusWaiting: 'ожидание',
    statusPlaying: 'играем',
    statusLabel: 'Статус',
    previewPlayers: 'Предпросмотр Игроков',
    joinRoom: 'Войти в Комнату',
    enterRoom: 'Войти в Комнату',
    yourRoom: 'Ваша Комната',
    gameRoom: 'Игровая Комната',
    
    // Game Room Lobby elements
    shareInvite: 'Пригласить Друзей',
    leaveRoom: 'Покинуть Комнату',
    iAmReady: 'Я Готов',
    cancelReady: 'Отменить Готовность',
    playersFinished: '{{finished}} из {{total}} игроков закончили',
    playersWaiting: '{{count}} игрок ждёт',
    playersWaitingPlural: '{{count}} игроков ждут',
    waitingForPlayers: 'Ожидание хотя бы ещё 1 игрока',
    startQuiz: 'Начать Викторину',
    startingQuiz: 'Запуск Викторины...',
    quizRoom: 'Комната Викторины',
    playing: 'Играем',
    finished: 'Закончил',
    disconnected: 'Отключен',
    // host: 'Хозяин', // Duplicate - already defined at line 433
    you: 'Вы',
    // ready: '✅ Готов', // Duplicate - already defined at line 434
    waitingStatus: 'Ожидание',
    startGame: 'Начать Викторину',
    starting: 'Запуск Викторины...',
    gameRoomTitle: 'Комната Викторины',
    hostLabel: 'Хозяин',
    iAmReadyButton: 'Я готов',
    readyButton: 'Готов',
    memberRoomTitle: 'Присоединитесь к комнате или создайте свою',
    memberRoomDescription: 'Присоединитесь к существующей комнате или создайте бесплатную комнату до 3 игроков.',
    freeHostEmptyEyebrow: 'Создать бесплатную комнату',
    freeHostEmptyTitle: 'Создать бесплатную комнату {{groupType}}',
    freeHostEmptyDescription: 'Бесплатные комнаты вмещают до 3 игроков. Обновитесь до Premium для больших игр.',
    freeHostActiveEyebrow: 'Ваша комната',
    freeHostActiveTitle: 'Ваша бесплатная комната {{groupType}} активна',
    freeHostActiveDescription: 'Ваша комната вмещает до 3 игроков. Обновитесь для большего.',
    freeHostBadge: 'Бесплатно · до 3 игроков',
    freeRoomFullTitle: 'Комната заполнена',
    freeRoomFullMessage: 'Бесплатные комнаты вмещают до 3 игроков. Обновитесь до Premium для больших семейных игр.',
    roomFullGeneric: 'Эта комната заполнена. Попробуйте другую.',
    loadingMultiplayerRoom: 'Загрузка многопользовательской комнаты...',
    loadingRoomDetails: 'Загрузка сведений о комнате...',
    goBackAccessibility: 'Назад',
    playersListAccessibility: 'Список игроков. Показывает всех игроков, ведущего и статус готовности.',
    quickMatch: 'Быстрая игра',
    createRoomAction: 'Создать комнату',
    joinByCodeAction: 'Войти по коду',
    shareInviteAccessibility: 'Поделиться ссылкой приглашения',
    readyStatusUpdateFailed: 'Не удалось обновить статус готовности. Попробуйте еще раз.',
    waitingForHostToStart: 'Ожидание начала от ведущего',
    playersInRoom: '{{count}} игроков в комнате',
    readyUpToStart: 'Отметьте себя готовым, чтобы ведущий мог начать викторину.',
    allPlayersReady: 'Все готовы',
    roomDetails: 'Сведения о комнате',
    players: 'Игроки',
    readyToBegin: 'Готово к началу',
    groupLobbyTitle: 'Лобби {{groupType}}',
    hostActiveDescription: 'Откройте комнату, проверьте участников и начните игру.',
    memberActiveDescription: 'Premium-комната открыта. Войдите здесь и продолжайте игру.',
    hostEmptyDescription: 'Создайте комнату, пригласите всех и управляйте игрой отсюда.',
    hostActiveEyebrow: 'Живая комната',
    memberActiveEyebrow: 'Войти в комнату',
    hostEmptyEyebrow: 'Открыть комнату',
    memberBadge: 'Семейный доступ',
    hostActiveTitle: 'Ваша комната {{groupType}} готова',
    memberActiveTitle: 'Ваша семейная комната активна',
    hostEmptyTitle: 'Начните живую комнату {{groupType}}',
    startGroupQuiz: 'Начать викторину {{groupType}}',
    memberRoomEmptyTitle: 'Семейной комнаты пока нет',
    memberRoomEmptyDescription: 'Следующая Premium-комната {{groupType}} появится здесь.',
    memberRoomChip: 'Вы сможете войти, когда комната откроется.',
    status: 'Статус',
    category: 'Категория',
    difficulty: 'Сложность',
  },

  tl: {
    noPlayersYet: 'Wala pang manlalaro',
    setupCategoryBadge: 'Setup ng Kuwarto',
    setupCategoryTitle: 'Pumili ng paksa ng kuwarto',
    setupCategorySubtitle: 'Piliin kung ano ang sabay-sabay na lalaruin ng iyong {{groupType}}.',
    setupTestamentBadge: 'Setup ng Kuwarto',
    setupTestamentTitle: 'Pumili ng landas ng kuwarto',
    setupTestamentSubtitle: 'Piliin kung paano tutuklasin ng kuwartong {{groupType}} na ito ang Kasulatan.',
    setupDifficultyTitle: 'Itakda ang hamon ng kuwarto',
    setupDifficultySubtitle: 'Piliin ang antas ng hamon para sa lahat sa kuwartong {{groupType}} na ito.',
    roomCreateFailed: 'Hindi namin magawa ang kuwarto ngayon. Pakisubukang muli.',
    // Tagalog translations
    createTitle: 'Lumikha ng Silid',
    stepChooseCategory: '1. Pumili ng Kategorya',
    stepSelectDifficulty: '2. Piliin ang Kahirapan',
    stepRoomType: '3. Uri ng Silid',
    public: 'Pampubliko',
    private: 'Pribado',
    buttonCreate: 'Lumikha',
    room: 'Silid',
    buttonCancel: 'Kanselahin',
    validationSelectCategory: 'Pakipili ang isang kategorya.',
    validationSelectDifficulty: 'Pakipili ang isang kahirapan.',
    noActiveRooms: 'Walang aktibong silid. Maging una na lumikha!',
    roomPlayersTitle: 'Mga Manlalaro ng {{roomName}}',
    loadingPlayers: 'Naglo-load ng mga manlalaro...',
    host: 'Host',
    ready: 'Handa',
    waiting: 'Naghihintay',
    dayStreak: '{{count}} araw na sunod-sunod',
    noPlayers: 'Wala pang mga manlalaro sa silid na ito',
    close: 'Isara',
    openChat: 'Buksan ang chat',
    openEmojiPicker: 'Buksan ang emoji picker',
    chatHelp: 'Tulong sa chat. I-tap para sa mga tip.',
    chatHelpDialog: 'Mga tip sa chat: Mag-type ng mensahe at pindutin ang ipadala. Gamitin ang emoji button para sa mabilis na reaksyon. Matagal na pindutin ang mensahe para sa mas maraming opsyon.',
    messagePlaceholder: 'Mag-type ng mensahe...',
    send: 'Ipadala ang mensahe',
    typingIndicator: 'May nag-ttype…',
    scrollLatest: 'Mag-scroll sa pinakabagong mensahe',
    emojiCategoryReactions: 'Mga Reaksyon',
    emojiCategoryFaces: 'Mga Mukha',
    emojiCategoryObjects: 'Mga Bagay',
    emojiCategorySymbols: 'Mga Simbolo',
    loadingRooms: 'Naglo-load ng mga silid...',
    shareJoinTeam: 'Sumali sa aking team sa Word of God Quiz! I-tap ang link na ito: {{url}}',
    loadingCategories: 'Naglo-load ng mga kategorya...',
    loadingProfile: 'Naglo-load ng inyong profile…',
    profileLoadFailed: 'Hindi ma-load ang profile',
    multiplayerLobby: 'Multiplayer Lobby',
    groupGameRoom: '{{groupName}} Game Room',
    lobbySubtitle: 'Sumali sa umiiral na silid, lumikha ng sarili ninyo, o gamitin ang mabilis na paghahanap para maglaro kaagad.',
    realTimeGameDescription: 'Maglaro nang live kasama ang inyong {{groupType}} sa real-time na quiz room!',
    realTimeGameButton: 'Magsimula ng Family Quiz',
    challengeDescription: 'Magpadala o tumanggap ng quiz challenges para maglaro sa sarili ninyong bilis.',
    challengeButton: 'Challenge (Async)',
    backButton: '←',
    
    // Game Room Card elements
    activeRooms: 'Mga Aktibong Silid',
    gameRoomCode: 'Code',
    statusWaiting: 'naghihintay',
    statusPlaying: 'naglalaro',
    statusLabel: 'Status',
    previewPlayers: 'Preview ng mga Manlalaro',
    joinRoom: 'Sumali sa Silid',
    enterRoom: 'Pumasok sa Silid',
    yourRoom: 'Inyong Silid',
    gameRoom: 'Silid ng Laro',
    
    // Game Room Lobby elements
    shareInvite: 'Imbitahan ang mga Kaibigan',
    leaveRoom: 'Umalis sa Silid',
    iAmReady: 'Handa Na Ako',
    cancelReady: 'Kanselahin ang Handa',
    playersFinished: '{{finished}} sa {{total}} na manlalaro tapos na',
    playersWaiting: '{{count}} manlalaro naghihintay',
    playersWaitingPlural: '{{count}} manlalaro naghihintay',
    waitingForPlayers: 'Naghihintay ng kahit 1 pang manlalaro',
    startQuiz: 'Simulan ang Quiz',
    startingQuiz: 'Nagsisimula ang Quiz...',
    quizRoom: 'Quiz Room',
    playing: 'Naglalaro',
    finished: 'Tapos',
    disconnected: 'Nawala',
    // host: 'Host', // Duplicate - already defined at line 514
    you: 'Ikaw',
    // ready: '✅ Handa', // Duplicate - already defined at line 515
    waitingStatus: 'Naghihintay',
    startGame: 'Simulan ang Quiz',
    starting: 'Nagsisimula ang Quiz...',
    gameRoomTitle: 'Quiz Room',
    hostLabel: 'Host',
    iAmReadyButton: 'Handa na ako',
    readyButton: 'Handa',
    memberRoomTitle: 'Sumali sa isang silid o gumawa ng sarili mo',
    memberRoomDescription: 'Sumali sa isang umiiral na silid, o magsimula ng libreng silid para sa hanggang 3 manlalaro.',
    freeHostEmptyEyebrow: 'Magsimula ng libreng silid',
    freeHostEmptyTitle: 'Magsimula ng libreng {{groupType}} na silid',
    freeHostEmptyDescription: 'Ang libreng mga silid ay para sa 3 manlalaro. Mag-upgrade sa Premium para sa mas malalaking laro.',
    freeHostActiveEyebrow: 'Ang iyong silid',
    freeHostActiveTitle: 'Ang iyong libreng {{groupType}} na silid ay live na',
    freeHostActiveDescription: 'Ang iyong silid ay para sa 3 manlalaro. Mag-upgrade para sa higit pa.',
    freeHostBadge: 'Libre · hanggang 3 manlalaro',
    freeRoomFullTitle: 'Puno na ang silid',
    freeRoomFullMessage: 'Ang libreng mga silid ay para sa 3 manlalaro. Mag-upgrade sa Premium para sa mas malalaking laro ng pamilya at kaibigan.',
    roomFullGeneric: 'Puno na ang silid na ito. Subukan ang iba.',
    loadingMultiplayerRoom: 'Naglo-load ng multiplayer room...',
    loadingRoomDetails: 'Naglo-load ng detalye ng silid...',
    goBackAccessibility: 'Bumalik',
    playersListAccessibility: 'Listahan ng mga manlalaro. Ipinapakita ang lahat ng manlalaro, host, at ready status.',
    quickMatch: 'Mabilisang laban',
    createRoomAction: 'Gumawa ng silid',
    joinByCodeAction: 'Sumali gamit ang code',
    shareInviteAccessibility: 'Ibahagi ang invite link',
    readyStatusUpdateFailed: 'Hindi na-update ang ready status. Pakisubukang muli.',
    waitingForHostToStart: 'Naghihintay sa host na magsimula',
    playersInRoom: '{{count}} manlalaro sa silid',
    readyUpToStart: 'I-mark ang sarili bilang ready para masimulan ng host ang quiz.',
    allPlayersReady: 'Handa na ang lahat',
    roomDetails: 'Detalye ng silid',
    players: 'Mga manlalaro',
    readyToBegin: 'Handa nang magsimula',
    groupLobbyTitle: '{{groupType}} lobby',
    hostActiveDescription: 'Buksan ang silid, tingnan kung sino ang nasa loob, at simulan ang laban.',
    memberActiveDescription: 'May bukas na Premium room ngayon. Sumali rito at ituloy ang laban.',
    hostEmptyDescription: 'Gumawa ng isang silid, imbitahan ang lahat, at pamahalaan ang laban dito.',
    hostActiveEyebrow: 'Live room',
    memberActiveEyebrow: 'Sumali sa silid',
    hostEmptyEyebrow: 'Buksan ang silid',
    memberBadge: 'Family access',
    hostActiveTitle: 'Handa na ang inyong {{groupType}} room',
    memberActiveTitle: 'Live na ang family room ninyo',
    hostEmptyTitle: 'Simulan ang live {{groupType}} room ninyo',
    startGroupQuiz: 'Simulan ang {{groupType}} quiz',
    memberRoomEmptyTitle: 'Wala pang family room',
    memberRoomEmptyDescription: 'Lilitaw dito ang susunod na Premium {{groupType}} room.',
    memberRoomChip: 'Makakasali kayo kapag nagbukas ang silid.',
    status: 'Status',
    category: 'Kategorya',
    difficulty: 'Hirap',
  },

  it: {
    noPlayersYet: 'Ancora nessun giocatore',
    setupCategoryBadge: 'Impostazione della stanza',
    setupCategoryTitle: 'Scegli un argomento per la stanza',
    setupCategorySubtitle: 'Scegli cosa giocherà insieme il tuo gruppo {{groupType}}.',
    setupTestamentBadge: 'Impostazione della stanza',
    setupTestamentTitle: 'Scegli un percorso per la stanza',
    setupTestamentSubtitle: 'Scegli come questa stanza {{groupType}} esplorerà le Scritture.',
    setupDifficultyTitle: 'Imposta la sfida della stanza',
    setupDifficultySubtitle: 'Scegli il livello di sfida per tutti in questa stanza {{groupType}}.',
    roomCreateFailed: 'Al momento non è stato possibile creare la stanza. Riprova.',
    // Italian translations
    createTitle: 'Crea una Stanza',
    stepChooseCategory: '1. Scegli una Categoria',
    stepSelectDifficulty: '2. Seleziona Difficoltà',
    stepRoomType: '3. Tipo di Stanza',
    public: 'Pubblica',
    private: 'Privata',
    buttonCreate: 'Crea',
    room: 'Stanza',
    buttonCancel: 'Annulla',
    validationSelectCategory: 'Per favore seleziona una categoria.',
    validationSelectDifficulty: 'Per favore seleziona una difficoltà.',
    noActiveRooms: 'Nessuna stanza attiva. Sii il primo a crearne una!',
    roomPlayersTitle: 'Giocatori di {{roomName}}',
    loadingPlayers: 'Caricamento giocatori...',
    host: 'Host',
    ready: 'Pronto',
    waiting: 'In attesa',
    dayStreak: '{{count}} giorni consecutivi',
    noPlayers: 'Ancora nessun giocatore in questa stanza',
    close: 'Chiudi',
    openChat: 'Apri chat',
    openEmojiPicker: 'Apri selettore emoji',
    chatHelp: 'Aiuto chat. Tocca per suggerimenti.',
    chatHelpDialog: 'Suggerimenti chat: Digita un messaggio e premi invia. Usa il pulsante emoji per reazioni rapide. Tieni premuto un messaggio per più opzioni.',
    messagePlaceholder: 'Digita un messaggio...',
    send: 'Invia messaggio',
    typingIndicator: 'Qualcuno sta scrivendo…',
    scrollLatest: 'Scorri agli ultimi messaggi',
    emojiCategoryReactions: 'Reazioni',
    emojiCategoryFaces: 'Volti',
    emojiCategoryObjects: 'Oggetti',
    emojiCategorySymbols: 'Simboli',
    loadingRooms: 'Caricamento stanze...',
    shareJoinTeam: 'Unisciti al mio team su Word of God Quiz! Tocca questo link: {{url}}',
    loadingCategories: 'Caricamento categorie...',
    loadingProfile: 'Caricamento del vostro profilo…',
    profileLoadFailed: 'Impossibile caricare il profilo',
    multiplayerLobby: 'Lobby Multiplayer',
    groupGameRoom: 'Stanza di Gioco {{groupName}}',
    lobbySubtitle: 'Unisciti a una stanza esistente, crea la tua, o usa la corrispondenza rapida per giocare istantaneamente.',
    realTimeGameDescription: 'Gioca dal vivo con il vostro {{groupType}} in una stanza quiz in tempo reale!',
    realTimeGameButton: 'Inizia un Quiz in Famiglia',
    challengeDescription: 'Invia o accetta sfide quiz per giocare al vostro ritmo.',
    challengeButton: 'Sfida (Asincrona)',
    backButton: '←',
    
    // Game Room Card elements
    activeRooms: 'Stanze Attive',
    gameRoomCode: 'Codice',
    statusWaiting: 'in attesa',
    statusPlaying: 'in gioco',
    statusLabel: 'Stato',
    previewPlayers: 'Anteprima Giocatori',
    joinRoom: 'Unisciti alla Stanza',
    enterRoom: 'Entra nella Stanza',
    yourRoom: 'La Tua Stanza',
    gameRoom: 'Stanza di Gioco',
    
    // Game Room Lobby elements
    shareInvite: 'Invita Amici',
    leaveRoom: 'Lascia Stanza',
    iAmReady: 'Sono Pronto',
    cancelReady: 'Annulla Pronto',
    playersFinished: '{{finished}} di {{total}} giocatori terminati',
    playersWaiting: '{{count}} giocatore in attesa',
    playersWaitingPlural: '{{count}} giocatori in attesa',
    waitingForPlayers: 'In attesa di almeno 1 altro giocatore',
    startQuiz: 'Inizia Quiz',
    startingQuiz: 'Avvio Quiz...',
    quizRoom: 'Stanza Quiz',
    playing: 'Giocando',
    finished: 'Finito',
    disconnected: 'Disconnesso',
    // host: 'Host', // Duplicate - already defined at line 595
    you: 'Tu',
    // ready: '✅ Pronto', // Duplicate - already defined at line 596
    waitingStatus: 'In attesa',
    startGame: 'Inizia Quiz',
    starting: 'Avvio Quiz...',
    gameRoomTitle: 'Stanza Quiz',
    hostLabel: 'Host',
    iAmReadyButton: 'Sono pronto',
    readyButton: 'Pronto',
    memberRoomTitle: 'Unisciti a una stanza o crea la tua',
    memberRoomDescription: 'Unisciti a una stanza esistente o avvia una stanza gratuita per un massimo di 3 giocatori.',
    freeHostEmptyEyebrow: 'Crea stanza gratuita',
    freeHostEmptyTitle: 'Crea una stanza gratuita di {{groupType}}',
    freeHostEmptyDescription: 'Le stanze gratuite ospitano fino a 3 giocatori. Passa a Premium per partite più grandi.',
    freeHostActiveEyebrow: 'La tua stanza',
    freeHostActiveTitle: 'La tua stanza gratuita di {{groupType}} è attiva',
    freeHostActiveDescription: 'La tua stanza ospita fino a 3 giocatori. Passa a Premium per di più.',
    freeHostBadge: 'Gratis · fino a 3 giocatori',
    freeRoomFullTitle: 'Stanza piena',
    freeRoomFullMessage: 'Le stanze gratuite ospitano fino a 3 giocatori. Passa a Premium per partite più grandi con famiglia e amici.',
    roomFullGeneric: 'Questa stanza è piena. Prova un\'altra.',
    loadingMultiplayerRoom: 'Caricamento stanza multiplayer...',
    loadingRoomDetails: 'Caricamento dettagli stanza...',
    goBackAccessibility: 'Indietro',
    playersListAccessibility: 'Elenco giocatori. Mostra tutti i giocatori, host e stato pronto.',
    quickMatch: 'Partita rapida',
    createRoomAction: 'Crea stanza',
    joinByCodeAction: 'Unisciti con codice',
    shareInviteAccessibility: 'Condividi link invito',
    readyStatusUpdateFailed: 'Impossibile aggiornare lo stato pronto. Riprova.',
    waitingForHostToStart: 'In attesa che l host inizi',
    playersInRoom: '{{count}} giocatori nella stanza',
    readyUpToStart: 'Segnati come pronto così l host può avviare il quiz.',
    allPlayersReady: 'Tutti sono pronti',
    roomDetails: 'Dettagli stanza',
    players: 'Giocatori',
    readyToBegin: 'Pronto per iniziare',
    groupLobbyTitle: 'Lobby {{groupType}}',
    hostActiveDescription: 'Apri la stanza, controlla chi e presente e avvia la partita.',
    memberActiveDescription: 'Una stanza Premium e aperta. Entra qui e continua la partita.',
    hostEmptyDescription: 'Crea una stanza, invita tutti e gestisci la partita da qui.',
    hostActiveEyebrow: 'Stanza live',
    memberActiveEyebrow: 'Entra nella stanza',
    hostEmptyEyebrow: 'Apri stanza',
    memberBadge: 'Accesso famiglia',
    hostActiveTitle: 'La tua stanza {{groupType}} e pronta',
    memberActiveTitle: 'La tua stanza famiglia e live',
    hostEmptyTitle: 'Avvia la tua stanza live {{groupType}}',
    startGroupQuiz: 'Avvia quiz {{groupType}}',
    memberRoomEmptyTitle: 'Ancora nessuna stanza famiglia',
    memberRoomEmptyDescription: 'La prossima stanza Premium {{groupType}} apparirà qui.',
    memberRoomChip: 'Potrai entrare appena la stanza sarà aperta.',
    status: 'Stato',
    category: 'Categoria',
    difficulty: 'Difficoltà',
  },

  am: {
    noPlayersYet: 'እስካሁን ተጫዋች የለም',
    setupCategoryBadge: 'የክፍል ዝግጅት',
    setupCategoryTitle: 'የክፍሉን ርዕስ ይምረጡ',
    setupCategorySubtitle: 'የ{{groupType}} ቡድንዎ በጋራ የሚጫወተውን ይምረጡ።',
    setupTestamentBadge: 'የክፍል ዝግጅት',
    setupTestamentTitle: 'የክፍሉን መንገድ ይምረጡ',
    setupTestamentSubtitle: 'ይህ የ{{groupType}} ክፍል ቅዱስ መጽሐፍን እንዴት እንደሚቃኝ ይምረጡ።',
    setupDifficultyTitle: 'የክፍሉን ፈተና ያስቀምጡ',
    setupDifficultySubtitle: 'በዚህ የ{{groupType}} ክፍል ላሉ ሁሉ የፈተና ደረጃውን ይምረጡ።',
    roomCreateFailed: 'አሁን ክፍሉን መፍጠር አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    // Amharic translations
    createTitle: 'ክፍል ፍጠር',
    stepChooseCategory: '1. ምድብ ምረጥ',
    stepSelectDifficulty: '2. ከባድነት ምረጥ',
    stepRoomType: '3. የክፍል አይነት',
    public: 'ይፋዊ',
    private: 'ግል',
    buttonCreate: 'ፍጠር',
    room: 'ክፍል',
    buttonCancel: 'ሰርዝ',
    validationSelectCategory: 'እባክዎ ምድብ ይምረጡ።',
    validationSelectDifficulty: 'እባክዎ ከባድነት ይምረጡ።',
    noActiveRooms: 'ምንም ንቁ ክፍሎች የሉም። የመጀመሪያው ይሁኑ!',
    roomPlayersTitle: 'የ{{roomName}} ተጫዋቾች',
    loadingPlayers: 'ተጫዋቾችን በመጫን ላይ...',
    host: 'አስተናጋጅ',
    ready: 'ዝግጁ',
    waiting: 'በመጠበቅ ላይ',
    dayStreak: '{{count}} ቀናት ተከታታይ',
    noPlayers: 'በዚህ ክፍል ውስጥ ተጫዋቾች የሉም',
    close: 'ዝጋ',
    openChat: 'ውይይት ክፈት',
    openEmojiPicker: 'ኢሞጂ መምረጫ ክፈት',
    chatHelp: 'የውይይት እርዳታ። ለምክሮች ንካ።',
    chatHelpDialog: 'የውይይት ምክሮች: መልዕክት ተይብ እና ላክ የሚለውን ጫን። ለፈጣን ምላሽ ኢሞጂ ቁልፍን ተጠቀም። ለተጨማሪ አማራጮች መልዕክቱን ረዘም ላለ ጊዜ ተጫን።',
    messagePlaceholder: 'መልዕክት ተይብ...',
    send: 'መልዕክት ላክ',
    typingIndicator: 'የሆነ ሰው እየጻፈ ነው…',
    scrollLatest: 'ወደ ቅርብ ጊዜ መልዕክቶች ሸብልል',
    emojiCategoryReactions: 'ምላሾች',
    emojiCategoryFaces: 'ፊቶች',
    emojiCategoryObjects: 'ዕቃዎች',
    emojiCategorySymbols: 'ምልክቶች',
    loadingRooms: 'ክፍሎችን በመጫን ላይ...',
    shareJoinTeam: 'በ Word of God Quiz ውስጥ ቡድኔን ተቀላቀሉ! ይህንን ማገናኛ ንኩ: {{url}}',
    loadingCategories: 'ምድቦችን በመጫን ላይ...',
    loadingProfile: 'የእርስዎን መገለጫ በመጫን ላይ…',
    profileLoadFailed: 'መገለጫን መጫን አልተሳካም',
    multiplayerLobby: 'ባለብዙ ተጫዋች አዳራሽ',
    groupGameRoom: '{{groupName}} የጨዋታ ክፍል',
    lobbySubtitle: 'ያለ ክፍል ተቀላቀሉ፣ የራስዎን ይፍጠሩ፣ ወይም ፈጣን ግጥሚያን ተጠቀሙ በአንድ ጊዜ ለመጫወት።',
    realTimeGameDescription: 'ከእርስዎ {{groupType}} ጋር በቀጥታ በእውነተኛ ጊዜ የጥያቄ ክፍል ውስጥ ይጫወቱ!',
    realTimeGameButton: 'የቤተሰብ ጥያቄ ይጫረም',
    challengeDescription: 'በራስዎ ፍጥነት ለመጫወት የጥያቄ ፈተናዎችን ይላኩ ወይም ይቀበሉ።',
    challengeButton: 'ፈተና (አሲንክሮነስ)',
    backButton: '←',
    
    // Game Room Card elements
    activeRooms: 'ንቁ ክፍሎች',
    gameRoomCode: 'ኮድ',
    statusWaiting: 'እየጠበቀ',
    statusPlaying: 'እየተጫወተ',
    statusLabel: 'ሁኔታ',
    previewPlayers: 'ተጫዋቾች ቅድመ እይታ',
    joinRoom: 'ክፍል ይቀላቀሉ',
    enterRoom: 'ክፍል ግቡ',
    yourRoom: 'የእርስዎ ክፍል',
    gameRoom: 'የጨዋታ ክፍል',
    
    // Game Room Lobby elements
    shareInvite: 'ገደኞችን ይጋቡ',
    leaveRoom: 'ክፍል ይውቱ',
    iAmReady: 'ዝጉ ነኝ',
    cancelReady: 'ዝጉነትን ሰርዝ',
    playersFinished: '{{finished}} ከ{{total}} ተጫዋቾች ተቀንተዋል',
    playersWaiting: '{{count}} ተጫዋች እየጠበቀ',
    playersWaitingPlural: '{{count}} ተጫዋቾች እየጠበቁ',
    waitingForPlayers: 'ቢያንስ 1 ተጨማሪ ተጫዋች እየጠበቀ',
    startQuiz: 'ጥያቄ ይጫረም',
    startingQuiz: 'ጥያቄ እየጫረመ...',
    quizRoom: 'የጥያቄ ክፍል',
    playing: 'እየተጫወተ',
    finished: 'ተቀንተዋል',
    disconnected: 'ተቸርቷል',
    // host: 'አስተናጋጅ', // Duplicate - already defined at line 676
    you: 'እርስዎ',
    // ready: '✅ ዝጉ', // Duplicate - already defined at line 677
    waitingStatus: 'እየጠበቀ',
    startGame: 'ጥያቄ ይጫረም',
    starting: 'ጥያቄ እየጫረመ...',
    gameRoomTitle: 'የጥያቄ ክፍል',
    hostLabel: 'አስተናጋጅ',
    iAmReadyButton: 'ዝጉ ነኝ',
    readyButton: 'ዝጉ',
    memberRoomTitle: 'ክፍል ይቀላቀሉ ወይም የራስዎን ይጀምሩ',
    memberRoomDescription: 'ወደ ያለ ክፍል ይቀላቀሉ ወይም እስከ 3 ተጫዋቾች ነፃ ክፍል ይጀምሩ።',
    freeHostEmptyEyebrow: 'ነፃ ክፍል ጀምር',
    freeHostEmptyTitle: 'ነፃ {{groupType}} ክፍል ጀምር',
    freeHostEmptyDescription: 'ነፃ ክፍሎች እስከ 3 ተጫዋቾች ያስተናግዳሉ። ለትልቅ ጨዋታዎች ወደ Premium ያሻሽሉ።',
    freeHostActiveEyebrow: 'ክፍልዎ',
    freeHostActiveTitle: 'ነፃ {{groupType}} ክፍልዎ ቀጥታ ነው',
    freeHostActiveDescription: 'ክፍልዎ እስከ 3 ተጫዋቾች ያስተናግዳል። ለበለጠ ያሻሽሉ።',
    freeHostBadge: 'ነፃ · እስከ 3 ተጫዋቾች',
    freeRoomFullTitle: 'ክፍሉ ሞልቷል',
    freeRoomFullMessage: 'ነፃ ክፍሎች እስከ 3 ተጫዋቾች ያስተናግዳሉ። ለትልቅ የቤተሰብ ጨዋታዎች ወደ Premium ያሻሽሉ።',
    roomFullGeneric: 'ይህ ክፍል ሞልቷል። እባክዎ ሌላ ይሞክሩ።',
    loadingMultiplayerRoom: 'የብዙ ተጫዋቾች ክፍል በመጫን ላይ...',
    loadingRoomDetails: 'የክፍል ዝርዝሮች በመጫን ላይ...',
    goBackAccessibility: 'ተመለስ',
    playersListAccessibility: 'የተጫዋቾች ዝርዝር። ሁሉንም ተጫዋቾች፣ አስተናጋጅን እና የዝግጁነት ሁኔታን ያሳያል።',
    quickMatch: 'ፈጣን ጨዋታ',
    createRoomAction: 'ክፍል ፍጠር',
    joinByCodeAction: 'በኮድ ይቀላቀሉ',
    shareInviteAccessibility: 'የግብዣ አገናኝ አጋራ',
    readyStatusUpdateFailed: 'የዝግጁነት ሁኔታን ማዘመን አልተቻለም። እባክዎ እንደገና ይሞክሩ።',
    waitingForHostToStart: 'አስተናጋጁ እንዲጀምር በመጠበቅ ላይ',
    playersInRoom: '{{count}} ተጫዋቾች በክፍሉ ውስጥ',
    readyUpToStart: 'አስተናጋጁ ጥያቄውን እንዲጀምር ራስዎን ዝግጁ ያድርጉ።',
    allPlayersReady: 'ሁሉም ዝግጁ ናቸው',
    roomDetails: 'የክፍል ዝርዝሮች',
    players: 'ተጫዋቾች',
    readyToBegin: 'ለመጀመር ዝግጁ',
    groupLobbyTitle: 'የ{{groupType}} ሎቢ',
    hostActiveDescription: 'ክፍሉን ይክፈቱ፣ ማን እንዳለ ይመልከቱ፣ እና ጨዋታውን ይጀምሩ።',
    memberActiveDescription: 'የPremium ክፍል ተከፍቷል። እዚህ ይቀላቀሉ እና ጨዋታውን ያስቀጥሉ።',
    hostEmptyDescription: 'አንድ ክፍል ፍጠሩ፣ ሁሉንም ይጋብዙ፣ እና ጨዋታውን ከዚህ ያስተዳድሩ።',
    hostActiveEyebrow: 'ቀጥታ ክፍል',
    memberActiveEyebrow: 'ክፍል ይቀላቀሉ',
    hostEmptyEyebrow: 'ክፍል ክፈት',
    memberBadge: 'የቤተሰብ መዳረሻ',
    hostActiveTitle: 'የ{{groupType}} ክፍልዎ ዝግጁ ነው',
    memberActiveTitle: 'የቤተሰብ ክፍልዎ ቀጥታ ነው',
    hostEmptyTitle: 'የቀጥታ {{groupType}} ክፍልዎን ይጀምሩ',
    startGroupQuiz: 'የ{{groupType}} ጥያቄን ይጀምሩ',
    memberRoomEmptyTitle: 'እስካሁን የቤተሰብ ክፍል የለም',
    memberRoomEmptyDescription: 'ቀጣዩ የPremium {{groupType}} ክፍል እዚህ ይታያል።',
    memberRoomChip: 'ክፍሉ ሲከፈት መቀላቀል ይችላሉ።',
    status: 'ሁኔታ',
    category: 'ምድብ',
    difficulty: 'የችግር ደረጃ',
  },

  ko: {
    noPlayersYet: '아직 플레이어가 없습니다',
    setupCategoryBadge: '방 설정',
    setupCategoryTitle: '방 주제를 선택하세요',
    setupCategorySubtitle: '{{groupType}} 그룹이 함께 플레이할 주제를 고르세요.',
    setupTestamentBadge: '방 설정',
    setupTestamentTitle: '방 경로를 선택하세요',
    setupTestamentSubtitle: '이 {{groupType}} 방이 성경을 탐구할 방식을 선택하세요.',
    setupDifficultyTitle: '방 난이도를 설정하세요',
    setupDifficultySubtitle: '이 {{groupType}} 방의 모두에게 적용될 난이도를 선택하세요.',
    roomCreateFailed: '지금은 방을 만들 수 없습니다. 다시 시도해 주세요.',
    // Korean translations
    createTitle: '방 만들기',
    stepChooseCategory: '1. 카테고리 선택',
    stepSelectDifficulty: '2. 난이도 선택',
    stepRoomType: '3. 방 유형',
    public: '공개',
    private: '비공개',
    buttonCreate: '만들기',
    room: '방',
    buttonCancel: '취소',
    validationSelectCategory: '카테고리를 선택해주세요.',
    validationSelectDifficulty: '난이도를 선택해주세요.',
    noActiveRooms: '활성 방이 없습니다. 첫 번째로 만드세요!',
    roomPlayersTitle: '{{roomName}} 플레이어',
    loadingPlayers: '플레이어 로딩 중...',
    host: '호스트',
    ready: '준비완료',
    waiting: '대기중',
    dayStreak: '{{count}}일 연속',
    noPlayers: '아직 이 방에 플레이어가 없습니다',
    close: '닫기',
    openChat: '채팅 열기',
    openEmojiPicker: '이모지 선택기 열기',
    chatHelp: '채팅 도움말. 팁을 위해 탭하세요.',
    chatHelpDialog: '채팅 팁: 메시지를 입력하고 보내기를 누르세요. 빠른 반응을 위해 이모지 버튼을 사용하세요. 더 많은 옵션을 위해 메시지를 길게 누르세요.',
    messagePlaceholder: '메시지를 입력하세요...',
    send: '메시지 보내기',
    typingIndicator: '누군가 입력중…',
    scrollLatest: '최신 메시지로 스크롤',
    emojiCategoryReactions: '반응',
    emojiCategoryFaces: '얼굴',
    emojiCategoryObjects: '객체',
    emojiCategorySymbols: '기호',
    loadingRooms: '방 로딩 중...',
    shareJoinTeam: 'Word of God Quiz에서 내 팀에 참여하세요! 이 링크를 탭하세요: {{url}}',
    loadingCategories: '카테고리 로딩 중...',
    loadingProfile: '프로필 로딩 중…',
    profileLoadFailed: '프로필을 불러오지 못했습니다',
    multiplayerLobby: '멀티플레이어 로비',
    groupGameRoom: '{{groupName}} 게임룸',
    lobbySubtitle: '기존 방에 참여하거나, 자신만의 방을 만들거나, 빠른 매치를 사용해 즉시 플레이하세요.',
    realTimeGameDescription: '실시간 퀴즈 방에서 {{groupType}}와 함께 라이브로 플레이하세요!',
    realTimeGameButton: '가족 퀴즈 시작',
    challengeDescription: '자신의 속도에 맞춰 플레이할 수 있는 퀴즈 도전을 보내거나 받으세요.',
    challengeButton: '챌린지 (비동기)',
    backButton: '←',
    
    // Game Room Card elements
    activeRooms: '활성 방',
    gameRoomCode: '코드',
    statusWaiting: '대기 중',
    statusPlaying: '플레이 중',
    statusLabel: '상태',
    previewPlayers: '플레이어 미리보기',
    joinRoom: '방 참여',
    enterRoom: '방 입장',
    yourRoom: '내 방',
    gameRoom: '게임 방',
    
    // Game Room Lobby elements
    shareInvite: '친구 초대',
    leaveRoom: '방 나가기',
    iAmReady: '준비 완료',
    cancelReady: '준비 취소',
    playersFinished: '{{total}}명 중 {{finished}}명 완료',
    playersWaiting: '{{count}}명 대기 중',
    playersWaitingPlural: '{{count}}명 대기 중',
    waitingForPlayers: '최소 1명의 플레이어가 더 필요합니다',
    startQuiz: '퀴즈 시작',
    startingQuiz: '퀴즈 시작 중...',
    quizRoom: '퀴즈 방',
    playing: '플레이 중',
    finished: '완료',
    disconnected: '연결 끊어짐',
    // host: '호스트', // Duplicate - already defined at line 757
    you: '나',
    // ready: '✅ 준비완료', // Duplicate - already defined at line 758
    waitingStatus: '대기중',
    startGame: '퀴즈 시작',
    starting: '퀴즈 시작 중...',
    gameRoomTitle: '퀴즈 방',
    hostLabel: '호스트',
    iAmReadyButton: '준비했어요',
    readyButton: '준비완료',
    memberRoomTitle: '방에 참여하거나 직접 만드세요',
    memberRoomDescription: '기존 방에 참여하거나 최대 3명의 무료 방을 시작하세요.',
    freeHostEmptyEyebrow: '무료 방 시작',
    freeHostEmptyTitle: '무료 {{groupType}} 방 시작하기',
    freeHostEmptyDescription: '무료 방은 최대 3명까지 참여할 수 있습니다. 더 큰 게임을 위해 프리미엄으로 업그레이드하세요.',
    freeHostActiveEyebrow: '내 방',
    freeHostActiveTitle: '무료 {{groupType}} 방이 진행 중입니다',
    freeHostActiveDescription: '방은 최대 3명까지 지원합니다. 더 많은 인원을 위해 업그레이드하세요.',
    freeHostBadge: '무료 · 최대 3명',
    freeRoomFullTitle: '방이 가득 찼습니다',
    freeRoomFullMessage: '무료 방은 최대 3명까지 지원합니다. 더 큰 가족 및 친구 게임을 위해 프리미엄으로 업그레이드하세요.',
    roomFullGeneric: '이 방이 가득 찼습니다. 다른 방을 시도해 주세요.',
    loadingMultiplayerRoom: '멀티플레이어 방 로딩 중...',
    loadingRoomDetails: '방 세부 정보 로딩 중...',
    goBackAccessibility: '뒤로 가기',
    playersListAccessibility: '플레이어 목록. 모든 플레이어, 호스트, 준비 상태를 보여줍니다.',
    quickMatch: '빠른 매치',
    createRoomAction: '방 만들기',
    joinByCodeAction: '코드로 참여',
    shareInviteAccessibility: '초대 링크 공유',
    readyStatusUpdateFailed: '준비 상태를 업데이트할 수 없습니다. 다시 시도해 주세요.',
    waitingForHostToStart: '호스트가 시작하기를 기다리는 중',
    playersInRoom: '방에 {{count}}명',
    readyUpToStart: '호스트가 퀴즈를 시작할 수 있도록 준비 완료로 표시하세요.',
    allPlayersReady: '모두 준비되었습니다',
    roomDetails: '방 세부 정보',
    players: '플레이어',
    readyToBegin: '시작 준비 완료',
    groupLobbyTitle: '{{groupType}} 로비',
    hostActiveDescription: '방을 열고 참여자를 확인한 뒤 경기를 시작하세요.',
    memberActiveDescription: 'Premium 방이 열려 있습니다. 여기에서 참여해 경기를 계속하세요.',
    hostEmptyDescription: '방을 만들고 모두를 초대해 여기에서 경기를 진행하세요.',
    hostActiveEyebrow: '라이브 방',
    memberActiveEyebrow: '방 참여',
    hostEmptyEyebrow: '방 열기',
    memberBadge: '가족 액세스',
    hostActiveTitle: '{{groupType}} 방이 준비되었습니다',
    memberActiveTitle: '가족 방이 열려 있습니다',
    hostEmptyTitle: '라이브 {{groupType}} 방 시작',
    startGroupQuiz: '{{groupType}} 퀴즈 시작',
    memberRoomEmptyTitle: '아직 가족 방이 없습니다',
    memberRoomEmptyDescription: '다음 Premium {{groupType}} 방이 여기에 표시됩니다.',
    memberRoomChip: '방이 열리면 참여할 수 있습니다.',
    status: '상태',
    category: '카테고리',
    difficulty: '난이도',
  },
};
